import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { Routes } from '€lib/routing';
import { fethApplications } from '€slices/applications';

const useApplications = () => {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === Routes.ApplicationsList) {
            dispatch(fethApplications());
        }
    }, [dispatch, location]);

    return null;
};

export default useApplications;
